import z from "zod";

const measurementReportErrorTypeValues = ["EAGLEVIEW_FILE_TYPE_NOT_SUPPORTED"] as const;

const measurementReportErrorTypeSchema = z.enum(measurementReportErrorTypeValues);
const MeasurementReportErrorType = measurementReportErrorTypeSchema.enum;
type MeasurementReportErrorType = z.infer<typeof measurementReportErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type MeasurementReportErrors = {
  errorType: typeof MeasurementReportErrorType.EAGLEVIEW_FILE_TYPE_NOT_SUPPORTED;
  data: {
    externalId: string;
    fileType: string;
  };
};

export const measurementReportErrorDetails: Record<MeasurementReportErrorType, ErrorDetails> = {
  [MeasurementReportErrorType.EAGLEVIEW_FILE_TYPE_NOT_SUPPORTED]: {
    sentryDescription: "EagleView cannot download the requested measurement file type",
  },
};
